import * as React from 'react'
import * as Redux from 'redux'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux'
import {CSSProperties} from 'react'
import {Diamonds} from '../Components/Diamonds'
import {MajorAccountsFooter} from '../Components/MajorAccountsFooter'
import {browserHistory} from 'react-router'
import * as Request from '../tgccRequest'
import {MajorAccountsOrderRoster} from './MajorAccountsOrderRoster'
import {CampusProofCard} from '../Components/CampusProofCard'
import {MajorAccountsHdr} from '../Components/MajorAccountsHdr'

const wrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    height: 'auto',
    width: '100%',
}

const contentStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor:'#E9E6E6',
    borderRadius:'20px',
    width:'748px',
    height:'auto',
    margin:'auto'
}

const statusStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontSize: '16px',
    letterSpacing: '3px',
    fontWeight: 100,
    textTransform: 'uppercase',
    textAlign: 'center',
    marginBottom: '10px',
    marginTop:'22px',
    color: '#616060',
    fontFamily:'BarlowMedium',
    '@media(max-width:414px)': {
        fontSize:'16px'
    },
    '@media(max-width:375px)': {
        fontSize:'15px'
    },
    '@media(max-width:320px)': {
        fontSize:'12px'
    }
}

// Define new styles for the access denied section
const accessDeniedStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f2f2f2',
    borderRadius: '10px',
    padding: '40px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    margin: '50px auto',
    maxWidth: '600px',
    textAlign: 'center',
};

const accessDeniedTitleStyle: React.CSSProperties = {
    color: '#E27558',
    fontSize: '28px',
    marginBottom: '20px',
    fontFamily: 'BarlowMedium',
};

const accessDeniedMessageStyle: React.CSSProperties = {
    fontSize: '16px',
    color: '#616060',
    marginBottom: '30px',
    fontFamily: 'BarlowLight',
};

const accessDeniedButtonStyle: React.CSSProperties = {
    backgroundColor: '#E27558',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    textTransform: 'uppercase',
    fontFamily: 'BarlowMedium',
};

const accessDeniedImageStyle: React.CSSProperties = {
    maxWidth: '210px', // Adjust size as needed
    marginBottom: '20px', // Space between the image and the title
};

const dashHdrLineR: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginRight:'10px'
}

const dashHdrLineL: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginLeft:'5px'
}

const dashText: React.CSSProperties = {
    display:'inline-block',
    letterSpacing:'0.3em',
    fontSize:'26px',
    fontFamily:'Lulo',
    color:'#616060'
}
const createAcc: React.CSSProperties ={
    textAlign:'center',
    marginTop:'100px'
}

const loadingStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '200px',
    fontFamily: 'BarlowMedium',
    color: '#616060',
    fontSize: '18px',
};

const pleaseLoginStyle: React.CSSProperties = {
    ...loadingStyle,
    marginTop: '80px',
};

const proofIdStyle: React.CSSProperties = {
    textAlign:'center',
    position:'relative',
    top:'25px',
    fontFamily:'BarlowMedium',
    color:'#616060'
}
const status: React.CSSProperties = {
    color:'#E27558'
}

class pageState {
    proof:  Tgcc.Proof;
    error?: string; 
}

class _MajorAccountsProofRoster extends React.Component<Tgcc.BaseProps, any>{
    state = new pageState();
    
    init = (login: Tgcc.LoginData) => {
        console.log('initial')
        if(login){
            var proofId = this.props.location.query.proofId;
            Request.getProof(login, proofId, this.proofLoaded, this.loadError);
        }
    }
    
    componentWillMount(){
        console.log('Component Did Mount:', this.props, this.state);

        if(this.props.state.LoginData)
            this.init(this.props.state.LoginData);
        else
            Tgcc.LoginUser( this.props.dispatch);
    }
    
    componentWillReceiveProps(props: any){
        console.log("componentWillRecieveProps")
        if(props.state.LoginData)
            this.init(props.state.LoginData);
    }
    componentDidMount(){
        console.log("componentDidMount)");

        var tag = document.getElementById('majorRoster');
        console.log(tag);
        //tag.scrollIntoView(true);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

proofLoaded = (proof, status) => {
    if (status === 204 || status === 304) {
        this.setState({ 
            error: "You do not have permission to access this proof/roster. Please sign in as the owner of the roster in order to view it.", 
            proof: null 
        });
    } else {
        this.setState({ proof: proof });
    }
}

    

    loadError = (err: any) => {
        console.log("error loading roster: ", err);
        this.setState({ error: err });
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    getRosters = () => {
        console.log("getRosters - major accounts");
        if(this.state.proof && this.state.proof.rosterCodes && this.state.proof.rosterCodes.length){
            var rosters = new Array();
            this.state.proof.rosterCodes.map( (value: string) => {
                rosters.push(<MajorAccountsOrderRoster key={value} rosterCode={value}/>);
            });
            return rosters;
        }
        return null;
    }
    getDashHeader(){
        return (
            <div style={createAcc}>
                <div style={dashHdrLineR}></div>
                <h1 style={dashText}>ORDER ROSTER</h1>
                <div style={dashHdrLineL}></div>

            </div>
        )
    }

    redirectToHome = () => {
        browserHistory.push(Tgcc.Routes.Home);
    }


    render() {
        // Check for error state and render error message
        if (this.state.error) {
            return (
                <div style={accessDeniedStyle}>
                    <img 
                        src="https://i.imgur.com/6D6pwGC.png"
                        alt="Cute Cow"
                        style={accessDeniedImageStyle}
                    />
                    <h2 style={accessDeniedTitleStyle}>Access Denied</h2>
                    <p style={accessDeniedMessageStyle}>
                        {this.state.error}
                    </p>
                    <button 
                        style={accessDeniedButtonStyle} 
                        onClick={this.redirectToHome}
                    >
                        Return to Home
                    </button>
                </div>
            );
        }

        var proof: Tgcc.Proof = this.state.proof;
        // Show "please log in" when not authenticated (login dialog is triggered by componentWillMount)
        if (!this.props.state.LoginData) {
            return (
                <div style={wrapperStyle}>
                    <MajorAccountsHdr />
                    <div style={pleaseLoginStyle}>
                        Please log in to view this roster.
                    </div>
                    <MajorAccountsFooter state={this.props.state} />
                </div>
            );
        }
        // Show loading state while proof is being fetched
        if (!proof) {
            return (
                <div style={wrapperStyle}>
                    <MajorAccountsHdr />
                    {this.getDashHeader()}
                    <div style={loadingStyle}>
                        Loading roster...
                    </div>
                    <MajorAccountsFooter state={this.props.state} />
                </div>
            );
        }

        var orderRosters = this.getRosters();
    
        return (
            <div style={wrapperStyle}>
                <div id='majorRoster'></div>
                <MajorAccountsHdr />
                {this.getDashHeader()}
                <div style={contentStyle} className="campusProofCont">
                    <div style={proofIdStyle}>{proof.proofId}</div>
                    <div style={statusStyle}>Order Status: <span style={status}>{proof.status}</span></div>
                    <CampusProofCard proofId={proof.proofId} />
                    {orderRosters}
                </div>
                <MajorAccountsFooter state={this.props.state} />
            </div>
        );
    }
}


const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { 
        state: state,
    }
};

export var MajorAccountsProofRoster = connect(mapStateToProps)(Radium(_MajorAccountsProofRoster));